import React, { useState, useEffect } from "react";
import { FaCartArrowDown } from "react-icons/fa6";
import { MdDeleteForever } from "react-icons/md";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "./QrCartItems.css";
import axios from 'axios';
// import { apiOutletInfo } from '../QrMenuFunctions';

const QrCardItemsParcel = () => {
    const [deliveryOption, setDeliveryOption] = useState('Guest House');
    const [selectedAddressId, setSelectedAddressId] = useState(0);
    const navigate = useNavigate()
    const [cartItems, setCartItems] = useState([]);
    const [LastFiveDegitsPass, setLastFiveDigitspass] = useState()
    const [confarm , setconfirmButton]= useState(false)






    const API_BASE_URL = process.env.REACT_APP_API_KEY;

    const [orderData, setOrderData] = useState({
        outletId: "",
        orderType: deliveryOption,
        orderDetails: [],
        orderMessage: "",
        customerId: "",
        deliveryDetail: [],
        deliveryAddress: "",
        deliveryInstructions: "",
        billDetail: {
            cgst: 0,
            sgst: 0,
            roundOff: 0,
        },
        roomNo: "",
        mobileNo: "",
        tableNo: "",
        distance: "",
        duration: "",
    });


    // const OutletInfoData = localStorage.getItem("outletInfo");
    const [outletinfo, setOutletInfo] = useState([]);
    const [guestHouseData, setGuestHouseData] = useState([])
    const [ordersbumitbutton, setOrderSubmitanble] = useState(false)
    const [getcustomerId, setCustomerData] = useState("");




    console.log("getcustomerId", getcustomerId);

    const GuestHousedata = async () => {
        try {
            const GuestResp = await axios.get(`${API_BASE_URL}GuestHouse/GetGuestHouseByGuestHouseId?guestHouseId=${localStorage.getItem("guestHouseId")}`)
            setGuestHouseData(GuestResp.data[0])
            console.log("GuestHouse data GetSuccessfully", GuestResp.data);
        } catch (error) {
            console.log("GuestHouse Data Get Error", error);
        }
    }

    useEffect(() => {
        GuestHousedata();
    }, [])


    const customerdata = async (value) => {
        // e.preventDefault(); // prevent form refresh

        setOrderSubmitanble(true)

        try {
            // Step 1: Try to fetch customer by mobile number
            const customerdataresp = await axios.get(
                `${API_BASE_URL}CustomerMaster/ByMobile/${value}`
            );

            console.log("Customer Found ✅", customerdataresp.data);

            const fetchedData = customerdataresp.data;
            setCustomerData(customerdataresp.data.customerId)

            setOrderData((prev) => ({
                ...prev,
                customerId: fetchedData.customerId,
                deliveryAddress: fetchedData.preferredAddress,
                customerName: fetchedData.customerName || "",
            }));



        } catch (error) {
            console.log("Get CustomerData api error ", error);
        }
    };



    const CusomerdataInsert = async () => {
        try {

            const addressData = {
                addressId: 0,
                addLine1: guestHouseData.guestHouseName,
                addLine2: orderData.roomNo,
                area: guestHouseData.area,
                latitude: guestHouseData.latitude,
                longitude: guestHouseData.longitude,
            };

            // Step 2: Register new customer if not found
            const registerData = {
                customerName: orderData.customerName,
                contactNo: orderData.mobileNo,
                contactEmail: "",
                password: LastFiveDegitsPass || 0,
                birthDate: null,
                anniversaryDate: null,
                addresses: [addressData],
                preferredAddress: null,
                outletId: orderData.outletId
            };

            const postResponse = await axios.post(
                `${API_BASE_URL}CustomerMaster`,
                registerData
            );

            console.log("Customer Created ✅", postResponse.data);

            const created = postResponse.data;
            setOrderData((prev) => ({
                ...prev,
                customerId: created.customerId,
                deliveryAddress: created.preferredAddress,
                customerName: created.customerName || "",
            }));
        } catch (postError) {
            console.error("❌ Error creating customer", postError);
            alert("Failed to register new customer.");
        }
    }


    const CusomerdataUpdate = async () => {
        try {

            const addressData = {
                addressId: 0,
                addLine1: guestHouseData.guestHouseName,
                addLine2: orderData.roomNo,
                area: guestHouseData.area,
                latitude: guestHouseData.latitude,
                longitude: guestHouseData.longitude,
            };

            // Step 2: Register new customer if not found
            const registerData = {
                customerName: orderData.customerName,
                contactNo: orderData.mobileNo,
                contactEmail: "",
                password: LastFiveDegitsPass || 0,
                birthDate: null,
                anniversaryDate: null,
                addresses: [addressData],
                preferredAddress: null,
                outletId: orderData.outletId
            };

            const postResponse = await axios.put(
                `${API_BASE_URL}CustomerMaster/${getcustomerId}`,
                registerData
            );

            console.log("Customer Created ✅", postResponse.data);

            const created = postResponse.data;
            setOrderData((prev) => ({
                ...prev,
                customerId: created.customerId,
                deliveryAddress: created.preferredAddress,
                customerName: created.customerName || "",
            }));
        } catch (postError) {
            console.error("❌ Error creating customer", postError);
            alert("Failed to register new customer.");
        }
    }

    const ComfarmButtonClick = async (e) => {
        e.preventDefault();
            setconfirmButton(true)
        if (!getcustomerId) {
            await CusomerdataInsert();
        } else {
            CusomerdataUpdate();
        }
    }








    // Fetch items from local storage on component mount
    useEffect(() => {
        const storedItems = JSON.parse(localStorage.getItem("selectedItems")) || [];
        const itemsWithQuantity = storedItems.map((item) => ({
            ...item,
            // Initialize quantity as 1
        }));
        setCartItems(itemsWithQuantity);
        // apiOutletInfo(setOutletInfo);
        apiOutletInfo()
    }, []);

    const storedData = JSON.parse(localStorage.getItem("outletdataLocal")) || {};

let outletId, outletlogo, outletName, kotPassword, kotOrderRequired, gstReq, gstPer, freeDistance, minDeliveryCharge, ratePerKm, preparationTime;

if (storedData?.data && Array.isArray(storedData.data) && storedData.data.length > 0) {
    const outlet = storedData.data[0]; // ✅ take first element
    outletId = outlet.outletId;
    outletlogo = outlet.outletlogo;
    outletName = outlet.outletName;
    kotPassword = outlet.kotPassword;
    kotOrderRequired = outlet.kotOrderRequired;
    gstReq = outlet.applyGST;
    gstPer = outlet.gstPer;
    freeDistance = outlet.freeDistance;
    minDeliveryCharge = outlet.minDeliveryCharge;
    ratePerKm = outlet.ratePerKm;
    preparationTime = outlet.preparationTime;
} else if (storedData && typeof storedData === "object") {
    // fallback if it's direct object
    outletId = storedData.outletId;
    outletlogo = storedData.outletlogo;
    outletName = storedData.outletName;
    kotPassword = storedData.kotPassword;
    kotOrderRequired = storedData.kotOrderRequired;
    gstReq = storedData.applyGST;
    gstPer = storedData.gstPer;
    freeDistance = storedData.freeDistance;
    minDeliveryCharge = storedData.minDeliveryCharge;
    ratePerKm = storedData.ratePerKm;
    preparationTime = storedData.preparationTime;
}

    console.log("outdatatest", outletId)

    const apiOutletInfo = async () => {


        try {
            const response = await axios.get(`${API_BASE_URL}OutletInfo/GetOutletInfoByOutletId?outletId=${outletId}`);
            setOutletInfo(response.data)

        } catch (error) {
            console.error("Error fetching outlet info:", error);
        }
    };



    useEffect(() => {
        setOrderData((prevData) => ({
            ...prevData,
            outletId: outletId,
            orderDetails: cartItems?.map((item) => ({
                qrItemId: item.qrItemId,
                rmsItemId: item.rmsItemId,
                qrItemName: item.qrItemName,
                itemMsg: item.itemMsg,
                rate: item.ApplayRate,
                quantity: item.Qty,
                amount: item.Amount,
            })) || [],
            deliveryDetail: {
                ...prevData.deliveryDetail,
                deliveryCharges: 0, // Ensure delivery charge is a number
            },
            billDetail: {
                ...prevData.billDetail,
                cgst: cgst || 0,
                sgst: sgst || 0,
                roundOff: rndOff || 0,
            }
        }));
    }, [cartItems, outletId]);



    const handleItemMsgChange = (index, value) => {
        const updatedItems = [...cartItems];
        updatedItems[index].itemMsg = value; // Update the item message for the specific item
        setCartItems(updatedItems);
        updateLocalStorage(updatedItems); // Update local storage
    };





    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent page refresh



        try {

            const response = await axios.post(`${API_BASE_URL}QrOrder`, orderData)
            console.log("rspOrder", response.data);

            if (response.data?.onlineOrderStatusDetails?.length > 0) {
                const latestStatus = response.data.onlineOrderStatusDetails[0];

                // Store in local storage
                localStorage.setItem("orderStatus", latestStatus.orderStatus);
                localStorage.setItem("statusTimestamp", latestStatus.statusTimestamp);

            }
            localStorage.setItem("orderId", response.data.orderId);
            navigate("/")
            clearSelectedItems();
            localStorage.removeItem("UpdateAndAddAddressId");


        } catch (error) {
            console.log("Your Order not posted Please call waitor", error);
        }
    }
    // Handle quantity increase
    const handleIncrease = (index) => {
        const updatedItems = [...cartItems];
        updatedItems[index].Qty += 1;

        setCartItems(updatedItems);
        updateLocalStorage(updatedItems);
    };

    // Handle quantity decrease
    const handleDecrease = (index) => {
        const updatedItems = [...cartItems];
        if (updatedItems[index].Qty > 1) {
            updatedItems[index].Qty -= 1;

            setCartItems(updatedItems);
            updateLocalStorage(updatedItems);
        }
    };

    const handleDelete = (index) => {
        const updatedItems = cartItems.filter((_, i) => i !== index);
        setCartItems(updatedItems);
        updateLocalStorage(updatedItems);
    };

    const clearSelectedItems = () => {
        localStorage.removeItem("selectedItems");

        setCartItems([]);
        //setSelectedItemsCount(0)
        console.log("Selected items cleared!");
    };

    // Update local storage
    const updateLocalStorage = (items) => {
        const itemsToStore = items.map(({ outletId, rmsItemId, qrItemId, qrItemName, ApplayRate, Qty }) => ({
            outletId,
            rmsItemId,
            qrItemId,
            qrItemName,
            ApplayRate,
            Qty,
        }));
        localStorage.setItem("selectedItems", JSON.stringify(itemsToStore));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Clear customer-related fields if mobile number is being updated
        if (name === "mobileNo") {
            setOrderData((prev) => ({
                ...prev,
                mobileNo: value,
                customerId: "",
                customerName: "",
                deliveryAddress: "",
            }));

            setCustomerData("");

            // Update last 5 digits
            if (value.length >= 5) {
                const last5 = value.slice(-5);
                setLastFiveDigitspass(last5);
            } else {
                setLastFiveDigitspass("");
            }

            // Fetch customer data if 10-digit number is complete
            if (value.length === 10) {
                customerdata(value);
            }

        } else {
            // For other fields, just update normally
            setOrderData((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    };
















    const ItemAmt = cartItems.reduce(
        (total, item) => total + item.ApplayRate * item.Qty,
        0
    )





    const cgst = gstPer !== null && gstPer !== 0 ? (ItemAmt * gstPer) / 200 : 0;
    const sgst = gstPer !== null && gstPer !== 0 ? (ItemAmt * gstPer) / 200 : 0;
    const totAmt = ItemAmt + cgst + sgst
    const rndOff = Math.round(totAmt) - totAmt


    const handleRoomChange = (e) => {
        const roomIndex = e.target.value;
        const room = guestHouseData?.rooms?.[roomIndex]; // assuming single guestHouse
        const outlatedata = guestHouseData?.gstOutlets?.[roomIndex]; // assuming single guestHouse

        if (room) {
            setOrderData((prev) => ({
                ...prev,
                roomNo: room.roomNo,
                tableNo: room.tblNo,
                distance: outlatedata.distance,
                duration: outlatedata.duration

            }));
        }
    };


    return (
        <>
            <div className="container-fluid">
                <div className="col-md-12">
                    <div className="row">
                        <nav className="navbar navbar-light bg-light shadow-sm bg-body rounded">
                            <div className="container-fluid">
                                <a className="navbar-brand" href="#">
                                    <img
                                        src={outletlogo}
                                        alt=""
                                        width={60}
                                        height={40}
                                        className="d-inline-block align-text-center me-2 img-fluid"
                                    />
                                    <strong className='mt-5'>
                                        {outletName}


                                        {/* <Link to="/Login">
                                                <button type="button" className="btn btn-primary" style={{ marginLeft: "50px" }}
                                                    onclick={localStorage.setItem("backPaath", "/QrCartItems")}
                                                >
                                                    Login
                                                </button>
                                            </Link> */}



                                    </strong>
                                </a>

                            </div>
                        </nav>
                        <div className="d-flex mt-1">
                            <FaCartArrowDown size={25} className="me-2" />
                            <h4>
                                <p>Your Cart Items</p>
                            </h4>
                            <div>
                                <Link to="/QrMenuPage">
                                    <button type="button" className='btn btn-outline-info p-0'
                                        style={{ height: "25px", marginTop: "1px", marginLeft: "78px" }}
                                        onClick={clearSelectedItems}
                                    >
                                        Clear Cart
                                    </button>
                                </Link>
                            </div>
                        </div>

                        <table className="cartTblcss">
                            <thead>
                                <tr className="border border-1 border-info">
                                    <td className="border border-1 border-info text-center">#</td>
                                    <td className="border border-1 border-info">Item Name</td>
                                    <td className="border border-1 border-info">Amount</td>
                                    <td className="border border-1 border-info">Quantity</td>
                                </tr>
                            </thead>
                            <tbody>
                                {cartItems.length > 0 ? (
                                    cartItems.map((item, index) => (
                                        <tr key={item.qrItemId}>
                                            <td
                                                style={{ width: "10%" }}
                                                className="border border-1 border-info text-center"
                                            >
                                                <MdDeleteForever size={25} color="red"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleDelete(index)}
                                                />
                                            </td>
                                            <td
                                                style={{ width: "55%" }}
                                                className="border border-1 border-info"
                                            >
                                                {item.qrItemName}
                                                <input
                                                    type="text"
                                                    value={item.itemMsg || ""}
                                                    placeholder="Enter Item Message"
                                                    style={{ height: "20px", width: "90%", marginLeft: "8px" }}
                                                    onChange={(e) => handleItemMsgChange(index, e.target.value)} // Handle input change for item message
                                                />
                                            </td>
                                            <td
                                                style={{ width: "15%" }}
                                                className="border border-1 border-info text-end"
                                            >
                                                {item.ApplayRate == 0 ? "APS" : item.ApplayRate * item.Qty}
                                            </td>
                                            <td
                                                style={{ width: "20%" }}
                                                className="border border-1 border-info"
                                            >
                                                <div
                                                    className="btn-group btn-group-sm"
                                                    role="group"
                                                    aria-label="Quantity control"
                                                >
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger"
                                                        onClick={() => handleDecrease(index)}
                                                    >
                                                        -
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-warning"
                                                        disabled
                                                    >
                                                        {item.Qty}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-success"
                                                        onClick={() => handleIncrease(index)}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="4"
                                            className="text-center border border-1 border-info"
                                        >
                                            No items in the cart
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                            <tfoot>
                                <tr>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>Item Amount:</strong>
                                    </td>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>
                                            {ItemAmt}
                                        </strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>CGST 2.5%:</strong>
                                    </td>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>
                                            {cgst}
                                        </strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>SGST 2.5%:</strong>
                                    </td>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>
                                            {sgst}
                                        </strong>

                                    </td>
                                </tr>

                                <tr>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>Round Off:</strong>
                                    </td>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>
                                            {rndOff}

                                        </strong>

                                    </td>

                                </tr>
                                <tr>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>Total Amount:</strong>
                                    </td>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>
                                            {Math.round(totAmt)}
                                        </strong>

                                    </td>
                                </tr>
                                {/* {delChrgs > 0 && (

)} */}




                            </tfoot>
                        </table>


                        <div className="mt-1">
                            <textarea type="text" className="form-control"
                                placeholder="Enter Order Message"
                                name="orderMessage"
                                value={orderData.orderMessage}
                                onChange={handleInputChange} />

                        </div>

                        <p style={{ fontSize: "13px" }}>
                            {guestHouseData.guestHouseName}
                        </p>



                        <form>
                            <div className="mb-3 d-flex">
                                <input
                                    type="text"
                                    name="mobileNo"
                                    className="form-control me-2"
                                    placeholder="Enter Mobile No"
                                    value={orderData.mobileNo}
                                    onChange={handleInputChange}
                                />
                                <input
                                    type="text"
                                    name="customerName"
                                    className="form-control"
                                    placeholder="Enter Name"
                                    value={orderData.customerName}
                                    onChange={handleInputChange}
                                />

                            </div>

                            <div className="mb-3 d-flex">
                                <select className="form-select me-4" onChange={handleRoomChange}>
                                    <option value="">Select Room No</option>
                                    {guestHouseData?.rooms?.map((room, index) => (
                                        <option key={index} value={index}>
                                            {room.roomNo}
                                        </option>
                                    ))}
                                </select>

                                <div className="col-5">
                                    <button
                                        className="btn btn-primary"
                                        onClick={ComfarmButtonClick}
                                        disabled={orderData.mobileNo.length !== 10 || !orderData.roomNo}
                                    >
                                        Confirm
                                    </button>

                                </div>
                            </div>
                        </form>




                        <div className="d-flex justify-content-center mt-2">


                            <button className="btn btn-success "
                               disabled={!ordersbumitbutton || !confarm}
                                onClick={handleSubmit}
                            >
                                Order Submit
                            </button>

                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default QrCardItemsParcel;
